import type { ComponentProps } from "react"

export default function Dataset(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <ellipse
        cx="12"
        cy="5"
        rx="9"
        ry="3"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5V19A9 3 0 0 0 21 19V5"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12A9 3 0 0 0 21 12"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
